import { Pagination } from 'antd'
import { Turbo } from '@hotwired/turbo-rails'

import { ComponentController } from './component_controller'

export class PaginationController extends ComponentController {
  static values = {
    totalText: String,
    pageParam: String,
    sizeParam: String,
  }

  declare readonly totalTextValue: string
  declare readonly pageParamValue: string
  declare readonly sizeParamValue: string

  get component() {
    return Pagination
  }

  get initialProps() {
    return {
      align: 'center',
      pageSizeOptions: [10, 20, 50, 100],
      showQuickJumper: true,
      showSizeChanger: true,
      showTotal: () => this.totalTextValue,
      ...this.propsFromData,
      onChange: this.handleChange.bind(this),
    }
  }

  handleChange(page: number, pageSize: number) {
    const url = new URL(window.location.href)
    url.searchParams.set(this.pageParamValue, page.toString())
    url.searchParams.set(this.sizeParamValue, pageSize.toString())
    Turbo.visit(url.toString())
  }
}
